import { ThingSummary } from '@rtls/core/models/thing/thing-summary.model';
import { nullable, randomName } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';
import { thingTypeFactory } from './thing-type.factory';

export const thingSummaryFactory = Factory.makeFactory<ThingSummary>({
	id: Factory.each((i) => nullable(i)),
	name: Factory.each(() => randomName()),
	types: Factory.each(() => [thingTypeFactory.build()]),
});
